import { State } from './reducer';
import { createSelector } from 'reselect';
import { name } from '../config';
import moment from 'moment';
import { CALENDAR_EVENT_DATE_FORMAT } from '~/config/formatters';

type StatePiece = { [key in typeof name]: typeof State['prototype'] };

export const getFeatureState = (state: StatePiece) => state[name];

export const selectDeals = createSelector(getFeatureState, state => state.deals);
export const selectDealSubTypeList = createSelector(getFeatureState, state => state.dealSubTypeList);
export const selectDealSummaryList = createSelector(getFeatureState, state => state.dealSummaryList);
export const selectDetectSongChange = createSelector(getFeatureState, state => state.detectSongChange);
export const selectLinkAllSongs = createSelector(getFeatureState, state => state.linkAllSong);
export const selectDealSubDeals = createSelector(getFeatureState, state => state.dealSubDeals);
export const selectDealDocuments = createSelector(getFeatureState, state => state.dealDocuments);

export const selectDealsResponse = createSelector(getFeatureState, state => state.dealsResponse);

export const selectNewDeal = createSelector(getFeatureState, state => state.newDeal);
export const selectNewDealStep = createSelector(getFeatureState, state => state.newDealFormStep);

export const selectNewSong = createSelector(getFeatureState, state => state.newSong);
//Search filter deal
export const searchDealFilter = createSelector(getFeatureState, state => state.searchDealFilter || '');
export const searchMoneyFilter = createSelector(getFeatureState, state => state.searchMoneyFilter || '');

export const searchSongFilter = createSelector(getFeatureState, state => state.searchSongFilter || '');
export const searchTeamFilter = createSelector(getFeatureState, state => state.searchTeamFilter || '');

export const songTagType = createSelector(getFeatureState, state => state.songTags);
export const selectNewSongStep = createSelector(getFeatureState, state => state.newSongFormStep);

export const selectContracts = createSelector(getFeatureState, state => state.contractsList);

export const selectMusicList = createSelector(getFeatureState, state => state.musicList);
export const songSummaryList = createSelector(getFeatureState, state => state.songSummary);

export const selectCalendarEvents = createSelector(getFeatureState, () => {
    return [moment().add(-14, 'days').format(CALENDAR_EVENT_DATE_FORMAT), moment().add(1, 'days').format(CALENDAR_EVENT_DATE_FORMAT)];
});

export const selectNawDrawerState = createSelector(getFeatureState, state => state.nawDrawerShowed);

export const selectIsSongEditing = createSelector(getFeatureState, state => state.isSongEditing);

export const selectIsDealEditing = createSelector(getFeatureState, state => state.isDealEditing);

export const selectUserData = createSelector(getFeatureState, state => {
    return state.activeCreator;
});

export const selectContacts = createSelector(getFeatureState, state => {
   return state.activeCreator?.contacts;
});

export const selectDocumentTypes = createSelector(getFeatureState, state => state.dealDocumentTypes);

export const selectActiveCreatorId = createSelector(getFeatureState, state => {
    return state.activeCreator?.userId;
});
export const getDealTypeList = createSelector(getFeatureState, state => state.dealTypeList);
export const getDealFormatList = createSelector(getFeatureState, state => state.dealFormatList);
export const getDealCodeList = createSelector(getFeatureState, state => state.dealCodeList);
export const getDealRegionsList = createSelector(getFeatureState, state => state.dealRegionList);
export const getContactTypeList = createSelector(getFeatureState, state => state.contactCodeList);
export const getCountryList = createSelector(getFeatureState, state => state.countryCodeList);
export const getSongListingsList = createSelector(getFeatureState, state => state.songListingsList);
export const getSoundListingsList = createSelector(getFeatureState, state => state.soundListingsList);
export const getArtworkListingsList = createSelector(getFeatureState, state => state.artworkListingsList);
export const getUserContact = createSelector(getFeatureState, state => state.contactCodeList);
export const getUserProfileData = createSelector(getFeatureState, state => state.userProfileData);
export const getAKAsList = createSelector(getFeatureState, state => state.AKAsList);
export const selectCurrentUser = createSelector(getFeatureState, state => {
    return state.currentContact;
});
